import { useState } from 'react';
import { format } from 'date-fns';
import type { DateRange } from 'react-day-picker';
import { usePulseSubcategoryCounts } from '@/hooks/use-pulse';
import { ImportPreviousTicketsDialog } from './import-previous-tickets-dialog';
import { FetchingTicketsDialog } from './fetching-tickets-dialog';

type WizardStep = 'import' | 'fetching';

interface PreviousTicketsWizardProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpenTicketCategorisation?: () => void;
}

// Pick a date range and fetch previous tickets, same as "My Ticket Categories" -> Fetch Tickets.
export function PreviousTicketsWizard({ open, onOpenChange, onOpenTicketCategorisation }: PreviousTicketsWizardProps) {
  const { fetchTickets } = usePulseSubcategoryCounts();

  const [step, setStep] = useState<WizardStep>('import');

  const closeAll = () => {
    setStep('import');
    onOpenChange(false);
  };

  const handleImport = (range: DateRange | undefined) => {
    fetchTickets({
      startDate: range?.from ? format(range.from, 'yyyy-MM-dd') : undefined,
      endDate: range?.to ? format(range.to, 'yyyy-MM-dd') : undefined
    });
    setStep('fetching');
  };

  return (
    <>
      <ImportPreviousTicketsDialog
        open={open && step === 'import'}
        onOpenChange={(isOpen) => !isOpen && closeAll()}
        onImport={handleImport}
      />
      <FetchingTicketsDialog
        open={open && step === 'fetching'}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            closeAll();
            onOpenTicketCategorisation?.();
          }
        }}
      />
    </>
  );
}
